import classes from './PageBuilderColumnLine.module.scss';
import type { ColumnLineType } from './columnLineConfigAggregator';

type PageBuilderColumnLineProps = ColumnLineType;

/**
 * Return the PB Column Line Block
 * @param props
 * @constructor
 */
export function PageBuilderColumnLine(props: PageBuilderColumnLineProps) {
    const columnLineClassNames = [classes['root'], 'pageBuilderColumnLineGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        columnLineClassNames.push(...props.cssClasses);
    }

    /**
     * Render the Column Line Block UI
     */
    return props.children;
}
